/* GreyBag - Teklif Studyosu.
   sections/gb-quote-studio.liquid ile calisir; ana sayfa ve /pages/teklif-al ayni
   dosyayi kullanir. Tema JS'ine bagli degildir. Bolum duzenleyicide yeniden
   cizildiginde custom element kendini kapatip yeniden kurar.
   Canvas motoru (cizim, jest, dosya okuma) V1 ile ayni; degisen arayuz ve akis. */
(function () {
  'use strict';
  if (window.customElements.get('gb-quote-studio')) return;

  var MAX_BYTES = 10 * 1024 * 1024;
  var MAX_SIDE = 1600;
  var WORK_SIDE = 4096;
  var SIZE_MIN = 15;
  var SIZE_MAX = 160;
  var SIZE_START = 70;
  var SEND_TIMEOUT = 45000;
  var CHALLENGE_GRACE = 6000;
  var FABRIC_PHOTO = 0.14;
  var FABRIC_SHADE = 0.9;
  var FABRIC_GAIN = 2.4;
  var MOCKUP_WIDTH = 900;
  var UPLOAD_WIDTH = 1400;
  var UPLOAD_QUALITY = 0.9;
  var UPLOAD_TIMEOUT = 180000;
  var DRAFT_AGE = 30 * 60 * 1000;
  var KEY_DRAFT = 'gb-quote-taslak';
  var KEY_DONE = 'gb-quote-kabul';
  var KEY_STARTED = 'gb-quote-basladi';
  var KEY_STILL = 'gb-quote-hareket';
  var KEY_PICK = 'gb2-secim';
  var DB_NAME = 'gb-quote';
  var DB_STORE = 'tasarim';
  var DB_KEY = 'son';
  var MIME = ['image/png', 'image/jpeg', 'image/webp'];
  var EXT = /\.(png|jpe?g|webp)$/i;
  var NAME_QTY = 'contact[Yaklasik adet araligi]';
  var NAME_SIZE = 'contact[Olcu tercihi]';
  var NAME_ID = 'contact[Talep Kimligi]';
  var UPLOAD_ERRORS = ['boyut', 'icerik', 'tur', 'bicim', 'talep', 'sinir', 'mesgul', 'sunucu', 'mockup'];
  var SOURCE_FIELDS = [
    ['utm_source', 'UTM source'],
    ['utm_medium', 'UTM medium'],
    ['utm_campaign', 'UTM campaign'],
    ['utm_content', 'UTM content'],
    ['utm_term', 'UTM term'],
    ['gclid', 'GCLID'],
    ['gbraid', 'GBRAID'],
    ['wbraid', 'WBRAID']
  ];
  var PRINT_CODES = { try: 'baskili', later: 'hazir_degil', none: 'baskisiz' };

  function clamp(v, min, max) { return Math.min(max, Math.max(min, v)); }
  function distance(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function readJson(getStorage, key) {
    try { return JSON.parse(getStorage().getItem(key) || 'null'); } catch (e) { return null; }
  }
  function session() { return window.sessionStorage; }
  function local() { return window.localStorage; }
  function writeSession(key, value) {
    try { session().setItem(key, value); } catch (e) { /* depolama kapali veya dolu */ }
  }
  function dropSession(key) {
    try { session().removeItem(key); } catch (e) { /* depolama kapali */ }
  }

  /* Ad, telefon, e-posta, serbest metin ve dosya adi HICBIR olaya konmaz. */
  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    var event = { event: name };
    Object.keys(params || {}).forEach(function (k) {
      if (params[k] !== undefined && params[k] !== '') event[k] = params[k];
    });
    window.dataLayer.push(event);
  }

  function challengeOpen() {
    return Array.from(document.querySelectorAll('iframe[src*="hcaptcha"]')).some(function (f) {
      var r = f.getBoundingClientRect();
      return r.height > 100 && r.bottom > 0 && window.getComputedStyle(f).visibility === 'visible';
    });
  }

  function formatSize(bytes) {
    if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
    return (bytes / (1024 * 1024)).toLocaleString('tr-TR', { maximumFractionDigits: 1 }) + ' MB';
  }

  /* ---------- tarayici depolamasi: gonderim basarisiz olursa dosya kaybolmasin ---------- */
  function withStore(mode, work) {
    return new Promise(function (resolve) {
      var open;
      try { open = window.indexedDB.open(DB_NAME, 1); } catch (e) { resolve(null); return; }
      open.onupgradeneeded = function () { open.result.createObjectStore(DB_STORE); };
      open.onerror = function () { resolve(null); };
      open.onsuccess = function () {
        var db = open.result;
        try {
          var tx = db.transaction(DB_STORE, mode);
          var req = work(tx.objectStore(DB_STORE));
          tx.oncomplete = function () { db.close(); resolve(req.result); };
          tx.onerror = tx.onabort = function () { db.close(); resolve(null); };
        } catch (e) {
          db.close();
          resolve(null);
        }
      };
    });
  }
  function keepFile(file) { return withStore('readwrite', function (s) { return s.put(file, DB_KEY); }); }
  function readFile() { return withStore('readonly', function (s) { return s.get(DB_KEY); }); }
  function clearFile() { return withStore('readwrite', function (s) { return s.delete(DB_KEY); }); }

  /* ---------- dosya kontrolu ---------- */
  function signature(buffer) {
    var b = new Uint8Array(buffer);
    if (b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4e && b[3] === 0x47) return 'png';
    if (b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) return 'jpeg';
    if (b[0] === 0x52 && b[1] === 0x49 && b[2] === 0x46 && b[3] === 0x46 &&
        b[8] === 0x57 && b[9] === 0x45 && b[10] === 0x42 && b[11] === 0x50) return 'webp';
    return '';
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () { if (img.naturalWidth) resolve(img); else reject(); };
      img.onerror = reject;
      img.src = url;
    });
  }

  function makeCanvas(w, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w));
    c.height = Math.max(1, Math.round(h));
    return c;
  }

  /* Buyuk gorsel kademeli kucultulur; tek adimda kucultme ince cizgileri bozar. */
  function shrink(img) {
    var sw = img.naturalWidth;
    var sh = img.naturalHeight;
    var k = Math.min(1, MAX_SIDE / Math.max(sw, sh));
    var tw = Math.round(sw * k);
    var th = Math.round(sh * k);
    var src = img;
    while (sw / 2 > tw) {
      var step = Math.min(0.5, WORK_SIDE / Math.max(sw, sh));
      var half = makeCanvas(sw * step, sh * step);
      var hx = half.getContext('2d');
      hx.imageSmoothingQuality = 'high';
      hx.drawImage(src, 0, 0, half.width, half.height);
      src = half;
      sw = half.width;
      sh = half.height;
    }
    var out = makeCanvas(tw, th);
    var ctx = out.getContext('2d', { willReadFrequently: true });
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(src, 0, 0, tw, th);
    return out;
  }

  function inspect(canvas) {
    var w = canvas.width;
    var h = canvas.height;
    var d = canvas.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    var opaque = true;
    var edge = 0;
    var white = 0;
    var i;
    for (i = 3; i < d.length; i += 4) {
      if (d[i] < 250) { opaque = false; break; }
    }
    function sample(p) {
      edge++;
      if (Math.min(d[p], d[p + 1], d[p + 2]) >= 236) white++;
    }
    for (i = 0; i < w; i++) { sample(i * 4); sample((w * (h - 1) + i) * 4); }
    for (i = 0; i < h; i++) { sample(i * w * 4); sample((i * w + w - 1) * 4); }
    return { opaque: opaque, whiteEdge: opaque && white / edge >= 0.9 };
  }

  /* Beyaz zemin kenardan iceri dogru silinir; logonun icindeki beyaz korunur. */
  function keyWhite(source) {
    var w = source.width;
    var h = source.height;
    var out = makeCanvas(w, h);
    var ctx = out.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(source, 0, 0);
    var img = ctx.getImageData(0, 0, w, h);
    var d = img.data;
    var seen = new Uint8Array(w * h);
    var stack = new Int32Array(w * h);
    var top = 0;
    function level(p) { var o = p * 4; return Math.min(d[o], d[o + 1], d[o + 2]); }
    function push(p) {
      if (seen[p] || level(p) < 228) return;
      seen[p] = 1;
      stack[top++] = p;
    }
    var i;
    for (i = 0; i < w; i++) { push(i); push(w * (h - 1) + i); }
    for (i = 0; i < h; i++) { push(i * w); push(i * w + w - 1); }
    while (top) {
      var p = stack[--top];
      var x = p % w;
      d[p * 4 + 3] = 0;
      if (x > 0) push(p - 1);
      if (x < w - 1) push(p + 1);
      if (p >= w) push(p - w);
      if (p < w * (h - 1)) push(p + w);
    }
    /* Silinen alana komsu yumusak kenarlar kademeli saydamlasir. */
    for (i = 0; i < seen.length; i++) {
      if (seen[i]) continue;
      var near = (i % w > 0 && seen[i - 1]) || (i % w < w - 1 && seen[i + 1]) ||
                 (i >= w && seen[i - w]) || (i < w * (h - 1) && seen[i + w]);
      if (near) d[i * 4 + 3] = clamp((255 - level(i)) / 65, 0, 1) * 255;
    }
    ctx.putImageData(img, 0, 0);
    return out;
  }

  /* Saydam bosluk kirpilir ki logo baski alanina gorunen haliyle ortalansin. */
  function trim(canvas) {
    var w = canvas.width;
    var h = canvas.height;
    var d = canvas.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    var l = w;
    var t = h;
    var r = -1;
    var b = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        if (d[(y * w + x) * 4 + 3] > 8) {
          if (x < l) l = x;
          if (x > r) r = x;
          if (y < t) t = y;
          if (y > b) b = y;
        }
      }
    }
    if (r < 0) return null;
    if (l === 0 && t === 0 && r === w - 1 && b === h - 1) return canvas;
    var out = makeCanvas(r - l + 1, b - t + 1);
    out.getContext('2d').drawImage(canvas, -l, -t);
    return out;
  }

  /* Olaylara giden sabit kod: secenek metninden uretilir, kisisel veri tasimaz. */
  function slug(value) {
    return String(value || '').toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g')
      .replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c')
      .replace(/[–—]/g, '-').replace(/\./g, '').replace(/×/g, 'x')
      .replace(/[^a-z0-9+-]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function navigationKind() {
    var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return nav ? nav.type : '';
  }

  function toBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(String(reader.result).split(',')[1]); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  var activeStudio = null;

  class GbQuoteStudio extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      /* Ayni belgede ikinci form olmaz: gb2-olcum ve hCaptcha formu kimlikle bulur.
         Duzenleyicide bolum yeniden yuklenince eskisi once ayrilir, burasi bosalir. */
      if (activeStudio && activeStudio !== this && activeStudio.isConnected) { this.remove(); return; }
      activeStudio = this;
      try {
        this.setup();
        this.classList.add('gb-quote-ready');
      } catch (err) {
        /* Form duz haliyle calismaya devam etsin. */
        this.classList.remove('gb-quote-boot', 'gb-quote-checking');
        this.querySelectorAll('[data-step]').forEach(function (el) { el.hidden = false; });
        console.error(err);
      }
    }

    disconnectedCallback() {
      if (activeStudio === this) activeStudio = null;
      this.abort.abort();
      if (this.resizer) this.resizer.disconnect();
      if (this.seen) this.seen.disconnect();
      clearInterval(this.sendTimer);
      clearTimeout(this.idleTimer);
      clearTimeout(this.liveTimer);
      this.releaseThumb();
      document.documentElement.classList.remove('gb2-hide-cta');
    }

    on(target, type, fn, options) {
      target.addEventListener(type, fn, Object.assign({ signal: this.abort.signal }, options));
    }

    q(selector) { return this.querySelector(selector); }
    all(selector) { return Array.from(this.querySelectorAll(selector)); }

    /* Ad, telefon, e-posta, serbest metin ve dosya adi olaya konmaz.
       form_location formun bulundugu sayfa turudur: homepage veya quote_page. */
    track(name, params) {
      track(name, Object.assign({ form_location: this.location }, params));
    }

    setup() {
      this.config = JSON.parse(this.q('[data-config]').textContent);
      this.text = this.config.text;
      this.form = this.q('form');
      this.location = this.getAttribute('data-location') || 'quote_page';
      this.uploadUrl = this.getAttribute('data-upload-url') || '';
      this.classList.add('gb-quote-boot');
      this.keepBarsAway();
      this.setupMotion();
      document.querySelectorAll('a[href$="/#gb2-teklif"]').forEach(function (a) {
        a.setAttribute('href', '#gb2-teklif');
      });
      var accepted = this.acceptance();
      this.classList.remove('gb-quote-checking');
      if (accepted) { this.showDone(accepted); return; }
      /* Eski /#gb2-teklif baglantilari bu bolume iner. */
      if (/^#gb2-teklif(-form)?$/.test(window.location.hash)) this.land(this.q(window.location.hash));

      this.form.noValidate = true;
      this.step = 1;
      this.model = 'tote';
      this.mode = 'fabric';
      this.choice = 'try';
      this.print = '';
      this.x = 0;
      this.y = 0;
      this.size = SIZE_START;
      this.design = null;
      this.press = 1;
      this.pointers = new Map();
      this.sentKinds = {};
      this.seenSteps = {};
      this.ink = document.createElement('canvas');
      this.mix = document.createElement('canvas');

      this.setupPreview();
      this.setupUpload();
      this.setupSteps();
      this.setupZoom();
      this.setupFields();
      this.setupModel();
      this.setupSubmit();
      this.setupKeyboard();
      this.paintChoice();
      this.goTo(1);
      this.restore();
    }

    /* Alt cubuk ve yuzen WhatsApp bu alandayken formun uzerine binmesin.
       Bolum ekrandan cikinca dekoratif zemin de bosuna calismasin. */
    keepBarsAway() {
      var self = this;
      if (!('IntersectionObserver' in window)) return;
      this.seen = new IntersectionObserver(function (entries) {
        document.documentElement.classList.toggle('gb2-hide-cta', entries[0].isIntersecting);
        self.classList.toggle('is-away', !entries[0].isIntersecting);
      }, { threshold: 0.02 });
      this.seen.observe(this);
    }

    /* Yalnizca dekoratif zemin hareket eder. Ziyaretci durdurabilir; sistemde
       hareket azaltma aciksa zemin zaten hic hareket etmez. */
    setupMotion() {
      var self = this;
      var button = this.q('[data-motion]');
      var still = false;
      try { still = local().getItem(KEY_STILL) === '1'; } catch (e) { /* depolama kapali */ }
      function paint() {
        self.classList.toggle('is-still', still);
        button.firstElementChild.textContent = still ? self.text.motionOn : self.text.motionOff;
      }
      button.hidden = reduced();
      paint();
      this.on(button, 'click', function () {
        still = !still;
        try { local().setItem(KEY_STILL, still ? '1' : '0'); } catch (e) { /* depolama kapali */ }
        paint();
      });
    }

    /* ---------- onizleme ---------- */
    setupPreview() {
      var self = this;
      this.stage = this.q('[data-stage]');
      this.canvas = this.q('[data-canvas]');
      this.ctx = this.canvas.getContext('2d');
      this.guide = this.q('[data-guide]');
      this.handle = this.q('[data-handle]');
      this.tools = this.q('[data-tools]');
      this.zoom = this.q('[data-zoom]');
      this.zoomValue = this.q('[data-zoom-value]');
      this.live = this.q('[data-live]');
      this.modeButtons = this.all('[data-mode]');
      this.bases = {};
      this.all('[data-base]').forEach(function (img) {
        self.bases[img.getAttribute('data-base')] = img;
        self.on(img, 'load', function () {
          if (img.getAttribute('data-base') === self.model) self.applyRatio();
          self.render();
          self.useRawBase(img);
        });
        if (img.complete && img.naturalWidth) self.useRawBase(img);
      });

      this.wide = window.matchMedia('(min-width: 900px)');
      this.on(this.wide, 'change', function () { self.paintMini(); });

      if ('ResizeObserver' in window) {
        this.resizer = new ResizeObserver(function () { self.fitCanvas(); });
        this.resizer.observe(this.stage);
      }
      this.on(window, 'resize', function () { self.fitCanvas(); });

      this.on(this.stage, 'pointerdown', function (e) { self.pointerDown(e); });
      this.on(this.stage, 'pointermove', function (e) { self.pointerMove(e); });
      this.on(this.stage, 'pointerup', function (e) { self.pointerUp(e); });
      this.on(this.stage, 'pointercancel', function (e) { self.pointerUp(e); });
      this.on(this.handle, 'keydown', function (e) { self.keyMove(e); });
      this.on(this.handle, 'focus', function () { self.setActive(true); });
      this.on(this.handle, 'blur', function () { self.setActive(false); });

      this.on(this.zoom, 'input', function () {
        self.size = Number(self.zoom.value);
        self.touched('yakinlastirma');
        self.setActive(true);
        self.schedule();
      });
      this.on(this.q('[data-center]'), 'click', function () {
        self.x = 0;
        self.y = 0;
        self.touched('ortala');
        self.setActive(true);
        self.schedule();
      });
      this.on(this.q('[data-reset]'), 'click', function () {
        self.x = 0;
        self.y = 0;
        self.size = SIZE_START;
        self.setMode('fabric');
        self.touched('sifirla');
        self.setActive(true);
        self.schedule();
      });
      this.modeButtons.forEach(function (b) {
        self.on(b, 'click', function () {
          self.setMode(b.getAttribute('data-mode'));
          self.touched('gorunum');
          self.schedule();
        });
      });

      this.placeGuide();
      this.applyRatio();
    }

    /* srcset'li gorselde naturalWidth ekran yogunluguna gore duzeltilir, drawImage
       ise ham piksel ister. Motor olcuyu naturalWidth'ten aldigi icin kumas haritasi
       telefonda ve 2x ekranda baski alani yerine gri fondan ornekleniyordu. Motora
       ayni dosyanin yogunluk duzeltmesiz kopyasi verilir; yeni dosya indirilmez. */
    useRawBase(img) {
      var self = this;
      var id = img.getAttribute('data-base');
      var raw = new Image();
      raw.crossOrigin = 'anonymous';
      raw.onload = function () {
        if (!raw.naturalWidth) return;
        self.bases[id] = raw;
        self.fabric = null;
        self.render();
      };
      raw.src = img.currentSrc || img.src;
    }

    area() {
      var a = this.config.models[this.model].area;
      var x = clamp(a.x, 0, 99);
      var y = clamp(a.y, 0, 99);
      return { x: x / 100, y: y / 100, w: clamp(a.w, 1, 100 - x) / 100, h: clamp(a.h, 1, 100 - y) / 100 };
    }

    areaPx() {
      var a = this.area();
      var W = this.canvas.width;
      var H = this.canvas.height;
      return { x: Math.round(W * a.x), y: Math.round(H * a.y), w: Math.round(W * a.w), h: Math.round(H * a.h) };
    }

    placeGuide() {
      var a = this.area();
      this.guide.style.left = a.x * 100 + '%';
      this.guide.style.top = a.y * 100 + '%';
      this.guide.style.width = a.w * 100 + '%';
      this.guide.style.height = a.h * 100 + '%';
    }

    applyRatio() {
      var img = this.bases[this.model];
      var ratio = img.naturalWidth ? img.naturalWidth / img.naturalHeight : parseFloat(img.getAttribute('data-ratio'));
      this.style.setProperty('--gb-quote-ratio', ratio);
      this.ratio = ratio;
      this.fitCanvas();
    }

    fitCanvas() {
      var box = this.stage.getBoundingClientRect();
      if (!box.width) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.round(box.width * dpr);
      var h = Math.round(box.height * dpr);
      if (this.canvas.width !== w || this.canvas.height !== h) {
        this.canvas.width = w;
        this.canvas.height = h;
      }
      this.render();
    }

    /* Tasarimin baski alani icindeki dikdortgeni. x ve y merkezin baski alanina
       orani oldugu icin model degisince yerlesim yeni alana uyum saglar. */
    rect(a) {
      var d = this.activeDesign();
      var k = Math.min(a.w / d.width, a.h / d.height) * (this.size / 100);
      var w = d.width * k;
      var h = d.height * k;
      return { x: a.w * (0.5 + this.x) - w / 2, y: a.h * (0.5 + this.y) - h / 2, w: w, h: h };
    }

    activeDesign() {
      var d = this.design;
      return d.keyed && d.useKey ? d.keyed : d.plain;
    }

    fabricFor(a) {
      var key = this.model + ':' + a.w + 'x' + a.h;
      if (this.fabric && this.fabric.key === key) return this.fabric;
      var base = this.bases[this.model];
      var kx = base.naturalWidth / this.canvas.width;
      var ky = base.naturalHeight / this.canvas.height;
      var photo = makeCanvas(a.w, a.h);
      photo.getContext('2d').drawImage(base, a.x * kx, a.y * ky, a.w * kx, a.h * ky, 0, 0, a.w, a.h);
      var shade = makeCanvas(a.w, a.h);
      var sx = shade.getContext('2d', { willReadFrequently: true });
      sx.drawImage(photo, 0, 0);
      var img;
      try { img = sx.getImageData(0, 0, a.w, a.h); } catch (e) { return null; }
      var p = img.data;
      var sum = 0;
      var i;
      for (i = 0; i < p.length; i += 4) sum += p[i] * 0.2126 + p[i + 1] * 0.7152 + p[i + 2] * 0.0722;
      var mean = sum / (p.length / 4);
      for (i = 0; i < p.length; i += 4) {
        var v = 128 + (p[i] * 0.2126 + p[i + 1] * 0.7152 + p[i + 2] * 0.0722 - mean) * FABRIC_GAIN;
        p[i] = p[i + 1] = p[i + 2] = v;
      }
      sx.putImageData(img, 0, 0);
      this.fabric = { key: key, photo: photo, shade: shade };
      return this.fabric;
    }

    /* Saf multiply beyaz logoyu yok eder. Bunun yerine tasarimin ustune once
       kumas fotografi cok dusuk opaklikla, sonra notr gri kirisik/doku haritasi
       soft-light ile biner; ikisi de yalnizca murekkebin oldugu piksellerde kalir. */
    inkLayer(a) {
      var ink = this.ink;
      var mix = this.mix;
      if (ink.width !== a.w || ink.height !== a.h) {
        ink.width = mix.width = a.w;
        ink.height = mix.height = a.h;
      }
      var x = ink.getContext('2d');
      var r = this.rect(a);
      x.globalCompositeOperation = 'source-over';
      x.globalAlpha = 1;
      x.imageSmoothingQuality = 'high';
      x.clearRect(0, 0, a.w, a.h);
      x.drawImage(this.activeDesign(), r.x, r.y, r.w, r.h);
      var fabric = this.mode === 'fabric' ? this.fabricFor(a) : null;
      if (!fabric) return ink;
      x.globalCompositeOperation = 'source-atop';
      x.globalAlpha = FABRIC_PHOTO;
      x.drawImage(fabric.photo, 0, 0);
      var m = mix.getContext('2d');
      m.globalCompositeOperation = 'copy';
      m.globalAlpha = 1;
      m.drawImage(ink, 0, 0);
      m.globalCompositeOperation = 'soft-light';
      m.globalAlpha = FABRIC_SHADE;
      m.drawImage(fabric.shade, 0, 0);
      m.globalCompositeOperation = 'destination-in';
      m.globalAlpha = 1;
      m.drawImage(ink, 0, 0);
      return mix;
    }

    render() {
      var c = this.canvas;
      var ctx = this.ctx;
      var base = this.bases && this.bases[this.model];
      if (!base || !c.width || !base.naturalWidth) return;
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, c.width, c.height);
      ctx.drawImage(base, 0, 0, c.width, c.height);
      var printing = this.design && this.print !== 'no';
      if (printing) {
        var a = this.areaPx();
        var layer = this.inkLayer(a);
        var s = 1 + 0.03 * (1 - this.press);
        ctx.save();
        ctx.beginPath();
        ctx.rect(a.x, a.y, a.w, a.h);
        ctx.clip();
        ctx.globalAlpha = this.press;
        ctx.drawImage(layer, a.x + a.w * (1 - s) / 2, a.y + a.h * (1 - s) / 2, a.w * s, a.h * s);
        ctx.restore();
      }
      c.classList.add('is-ready');
      this.stage.classList.toggle('has-design', !!printing);
      this.placeHandle(printing);
      this.paintZoom();
    }

    schedule() {
      var self = this;
      if (this.queued) return;
      this.queued = true;
      requestAnimationFrame(function () {
        self.queued = false;
        self.render();
      });
    }

    placeHandle(printing) {
      var h = this.handle;
      h.hidden = !printing;
      if (!printing) return;
      var a = this.areaPx();
      var r = this.rect(a);
      var W = this.canvas.width;
      var H = this.canvas.height;
      h.style.left = (a.x + r.x) / W * 100 + '%';
      h.style.top = (a.y + r.y) / H * 100 + '%';
      h.style.width = r.w / W * 100 + '%';
      h.style.height = r.h / H * 100 + '%';
    }

    paintZoom() {
      var v = Math.round(this.size);
      this.zoom.value = v;
      this.zoom.setAttribute('aria-valuetext', '%' + v);
      this.zoomValue.textContent = '%' + v;
    }

    setMode(mode) {
      this.mode = mode;
      this.modeButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-mode') === mode));
      });
    }

    /* Tek ozel an: tasarim kumasa basilir gibi yerine oturur. */
    pressIn() {
      var self = this;
      if (reduced()) { this.press = 1; this.render(); return; }
      var start = performance.now();
      this.press = 0;
      function tick(now) {
        var t = Math.min(1, (now - start) / 420);
        self.press = 1 - Math.pow(1 - t, 3);
        self.render();
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    setActive(on) {
      var self = this;
      clearTimeout(this.idleTimer);
      this.handle.classList.toggle('is-active', on);
      this.stage.classList.toggle('is-editing', on);
      if (on && !this.gesture) {
        this.idleTimer = setTimeout(function () { self.setActive(false); }, 1800);
      }
    }

    /* Sinirli siklik: her etkilesim turu tasarim basina bir kez yazilir,
       surukleme sirasinda piksel piksel olay gonderilmez. */
    touched(kind) {
      if (this.sentKinds[kind]) return;
      this.sentKinds[kind] = true;
      this.track('mockup_interaction', { etkilesim: kind, adim: this.step });
    }

    clampPlacement() {
      this.x = clamp(this.x, -0.5, 0.5);
      this.y = clamp(this.y, -0.5, 0.5);
      this.size = clamp(this.size, SIZE_MIN, SIZE_MAX);
    }

    pointerDown(e) {
      if (!this.design || (e.pointerType === 'mouse' && e.button !== 0)) return;
      if (!e.target.closest('[data-handle]') && !this.pointers.size) return;
      e.preventDefault();
      this.stage.setPointerCapture(e.pointerId);
      this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      this.gesture = this.readGesture(e.target.closest('[data-grip]'));
      this.handle.focus({ preventScroll: true });
      this.setActive(true);
    }

    readGesture(grip) {
      var pts = Array.from(this.pointers.values());
      var box = this.stage.getBoundingClientRect();
      var a = this.area();
      var g = {
        kind: 'move', x: this.x, y: this.y, size: this.size,
        areaW: box.width * a.w, areaH: box.height * a.h,
        start: pts.map(function (p) { return { x: p.x, y: p.y }; })
      };
      if (pts.length > 1) {
        g.kind = 'pinch';
        g.dist = distance(pts[0], pts[1]) || 1;
        g.mid = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
      } else if (grip) {
        var h = this.handle.getBoundingClientRect();
        g.kind = 'scale';
        g.center = { x: h.left + h.width / 2, y: h.top + h.height / 2 };
        g.dist = distance(pts[0], g.center) || 1;
      }
      return g;
    }

    pointerMove(e) {
      if (!this.pointers.has(e.pointerId) || !this.gesture) return;
      this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var g = this.gesture;
      var pts = Array.from(this.pointers.values());
      if (g.kind === 'move') {
        this.x = g.x + (pts[0].x - g.start[0].x) / g.areaW;
        this.y = g.y + (pts[0].y - g.start[0].y) / g.areaH;
      } else if (g.kind === 'scale') {
        this.size = g.size * distance(pts[0], g.center) / g.dist;
      } else if (pts.length > 1) {
        var mid = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
        this.size = g.size * distance(pts[0], pts[1]) / g.dist;
        this.x = g.x + (mid.x - g.mid.x) / g.areaW;
        this.y = g.y + (mid.y - g.mid.y) / g.areaH;
      }
      this.clampPlacement();
      this.schedule();
    }

    pointerUp(e) {
      if (!this.pointers.has(e.pointerId)) return;
      var g = this.gesture;
      this.pointers.delete(e.pointerId);
      if (this.pointers.size) { this.gesture = this.readGesture(null); return; }
      this.gesture = null;
      if (g) this.touched(g.kind === 'move' ? 'surukleme' : 'yakinlastirma');
      this.setActive(true);
    }

    keyMove(e) {
      var step = e.shiftKey ? 0.05 : 0.01;
      var kind = 'surukleme';
      if (e.key === 'ArrowLeft') this.x -= step;
      else if (e.key === 'ArrowRight') this.x += step;
      else if (e.key === 'ArrowUp') this.y -= step;
      else if (e.key === 'ArrowDown') this.y += step;
      else if (e.key === '+' || e.key === '=') { this.size += 2; kind = 'yakinlastirma'; }
      else if (e.key === '-' || e.key === '_') { this.size -= 2; kind = 'yakinlastirma'; }
      else return;
      e.preventDefault();
      this.clampPlacement();
      this.touched(kind);
      this.setActive(true);
      this.schedule();
      this.announce(this.text.liveMoved);
    }

    announce(message) {
      var self = this;
      clearTimeout(this.liveTimer);
      this.liveTimer = setTimeout(function () { self.live.textContent = message; }, 400);
    }

    /* ---------- yukleme ---------- */
    setupUpload() {
      var self = this;
      this.drop = this.q('[data-drop]');
      this.fileRow = this.q('[data-file-row]');
      this.fileThumb = this.q('[data-file-thumb]');
      this.fileName = this.q('[data-file-name]');
      this.fileInputs = this.all('[data-file]');
      this.uploadErr = this.q('[data-upload-error]');
      this.notice = this.q('[data-notice]');
      this.noticeSend = this.q('[data-notice-send]');
      this.altNote = this.q('[data-alt-note]');
      this.whiteNote = this.q('[data-white-note]');
      this.whiteText = this.q('[data-white-text]');
      this.whiteUndo = this.q('[data-white-undo]');
      this.whiteRow = this.q('[data-white-row]');
      this.whiteToggle = this.q('[data-white-toggle]');
      this.choices = this.all('[data-choice]').filter(function (el) { return el.tagName === 'INPUT'; });

      this.fileInputs.forEach(function (input) {
        self.on(input, 'change', function () {
          self.takeFile(input.files[0]);
          input.value = '';
        });
      });
      this.on(this.q('[data-file-remove]'), 'click', function () { self.removeDesign(); });
      this.on(this.whiteToggle, 'change', function () { self.setWhite(self.whiteToggle.checked); });
      this.on(this.whiteUndo, 'click', function () { self.setWhite(!self.design.useKey); });
      this.choices.forEach(function (r) {
        self.on(r, 'change', function () { self.setChoice(r.getAttribute('data-choice')); });
      });

      function hasFile(e) {
        return e.dataTransfer && Array.from(e.dataTransfer.types || []).indexOf('Files') > -1;
      }
      this.on(this, 'dragover', function (e) {
        if (!hasFile(e) || self.step !== 1) return;
        e.preventDefault();
        self.classList.add('is-dragging');
      });
      this.on(this, 'dragleave', function (e) {
        if (!self.contains(e.relatedTarget)) self.classList.remove('is-dragging');
      });
      this.on(this, 'drop', function (e) {
        if (!hasFile(e)) return;
        e.preventDefault();
        self.classList.remove('is-dragging');
        if (self.step === 1) self.takeFile(e.dataTransfer.files[0]);
      });
    }

    showUploadError(message) {
      this.uploadErr.textContent = message;
      this.uploadErr.hidden = !message;
    }

    takeFile(file) {
      var self = this;
      var t = this.text;
      if (!file) return;
      this.showUploadError('');
      if ((file.type && MIME.indexOf(file.type) === -1) || !EXT.test(file.name)) {
        this.showUploadError(t.errType);
        return;
      }
      if (file.size > MAX_BYTES) {
        this.showUploadError(t.errSize);
        return;
      }
      this.readDesign(file).then(function () {
        self.sentKinds = {};
        self.uploadSkipped = false;
        self.x = 0;
        self.y = 0;
        self.size = SIZE_START;
        self.setMode('fabric');
        keepFile(file);
        self.markStart();
        self.setChoice('try');
        self.track('design_upload', { dosya_turu: self.design.kind, adim: self.step });
        self.pressIn();
        self.revealStage();
        self.setActive(true);
        self.announce(t.liveLoaded);
      }).catch(function () {
        self.showUploadError(t.errRead);
      });
    }

    readDesign(file) {
      var self = this;
      var url = '';
      var kind = '';
      return file.slice(0, 12).arrayBuffer().then(function (head) {
        kind = signature(head);
        if (!kind) throw new Error('imza');
        url = URL.createObjectURL(file);
        return loadImage(url);
      }).then(function (img) {
        var shrunk = shrink(img);
        var info = inspect(shrunk);
        var plain = info.opaque ? shrunk : trim(shrunk);
        if (!plain) throw new Error('bos');
        var keyed = info.whiteEdge ? trim(keyWhite(shrunk)) : null;
        self.releaseThumb();
        self.thumbUrl = url;
        self.design = {
          file: file, kind: kind, plain: plain, keyed: keyed, useKey: !!keyed,
          width: img.naturalWidth, height: img.naturalHeight
        };
        self.paintFileRow();
        self.render();
      }).catch(function (err) {
        if (url) URL.revokeObjectURL(url);
        throw err;
      });
    }

    /* Yukleme biter bitmez sonuc ekranda olsun. Sayfa asagidaysa sahneye donulur. */
    revealStage() {
      var self = this;
      requestAnimationFrame(function () {
        var r = self.stage.getBoundingClientRect();
        if (r.top >= 0 && r.bottom <= window.innerHeight) return;
        self.stage.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' });
      });
    }

    paintFileRow() {
      var d = this.design;
      var t = this.text;
      if (d) {
        var thumb = new Image();
        thumb.alt = '';
        thumb.src = this.thumbUrl;
        this.fileThumb.replaceChildren(thumb);
        this.fileName.textContent = d.file.name;
        this.fileName.title = d.file.name;
        this.whiteToggle.checked = d.useKey;
        this.whiteText.textContent = d.useKey ? t.whiteHidden : t.whiteShown;
        this.whiteUndo.textContent = d.useKey ? t.whiteUndo : t.whiteRedo;
      }
      this.paintChoice();
    }

    /* Beyaz zemini gizlemek tasarimi degistirebilir: ziyaretci gorur, geri alir. */
    setWhite(on) {
      if (!this.design) return;
      this.design.useKey = on;
      this.paintFileRow();
      this.schedule();
    }

    removeDesign() {
      this.design = null;
      this.releaseThumb();
      clearFile();
      this.paintFileRow();
      this.showUploadError('');
      this.render();
      this.fileInputs[0].focus();
    }

    releaseThumb() {
      if (this.thumbUrl) URL.revokeObjectURL(this.thumbUrl);
      this.thumbUrl = '';
    }

    /* Uc yol: tasarim dene, tasarim hazir degil, baskisiz. Son ikisi dosyasiz
       ilerler ve onizlemede baski gostermez. */
    setChoice(value) {
      this.choice = value;
      this.print = value === 'try' ? '' : 'no';
      this.setAttribute('data-choice', value);
      this.choices.forEach(function (r) { r.checked = r.getAttribute('data-choice') === value; });
      this.showUploadError('');
      this.paintChoice();
      this.schedule();
    }

    paintChoice() {
      var t = this.text;
      var trying = this.choice === 'try';
      var d = this.design;
      var keyed = !!(d && d.keyed);
      this.drop.hidden = !trying || !!d;
      this.fileRow.hidden = !trying || !d;
      this.tools.hidden = !trying || !d;
      this.whiteNote.hidden = !trying || !keyed;
      this.whiteRow.hidden = !keyed;
      this.notice.hidden = !trying;
      this.noticeSend.hidden = !this.activeFile();
      this.altNote.hidden = trying;
      if (!trying) this.altNote.textContent = this.choice === 'none' ? t.altNone : t.altLater;
      this.classList.toggle('has-file', trying && !!d);
      this.paintBar();
    }

    activeFile() { return this.choice === 'try' ? this.design : null; }

    /* ---------- adimlar ---------- */
    setupSteps() {
      var self = this;
      this.steps = this.all('[data-step]');
      this.tabs = this.all('[data-step-tab]');
      this.bar = this.q('[data-action-bar]');
      this.nextBtn = this.q('[data-next]');
      this.backBtn = this.q('[data-back]');
      this.mini = this.q('[data-mini]');

      this.on(this.nextBtn, 'click', function () { self.next(); });
      this.on(this.backBtn, 'click', function () { self.goTo(self.step - 1, true); });
      /* Gonderim surerken adim degismez: yukleme bitince form son adimda gonderilir. */
      this.on(this.q('[data-edit]'), 'click', function () {
        if (!self.sending) self.goTo(2, true);
      });
      this.tabs.forEach(function (tab) {
        self.on(tab.querySelector('button'), 'click', function () {
          if (!self.sending) self.jump(Number(tab.getAttribute('data-step-tab')));
        });
      });
    }

    /* Ileri atlarken aradaki adimlar da gecerli olmali. */
    jump(target) {
      for (var i = this.step; i < target; i++) {
        if (i !== this.step) this.goTo(i, true);
        if (!this.stepValid(i)) return;
      }
      this.goTo(target, true);
    }

    goTo(n, moveFocus) {
      this.step = n;
      this.setAttribute('data-at', n);
      this.steps.forEach(function (s) { s.hidden = Number(s.getAttribute('data-step')) !== n; });
      this.tabs.forEach(function (tab) {
        var i = Number(tab.getAttribute('data-step-tab'));
        tab.classList.toggle('is-done', i < n);
        if (i === n) tab.setAttribute('aria-current', 'step');
        else tab.removeAttribute('aria-current');
      });
      this.paintMini();
      this.paintBar();
      this.paintRecap();
      this.viewStep(n);
      if (n === 1) this.fitCanvas();
      if (!moveFocus) return;
      var title = this.q('[data-step="' + n + '"] .gb-quote-step-title');
      title.focus({ preventScroll: true });
      var list = this.q('[data-steps]');
      if (list.getBoundingClientRect().top < 0) list.scrollIntoView({ block: 'start' });
    }

    next() {
      if (this.stepValid(this.step)) this.goTo(this.step + 1, true);
    }

    stepReady(n) {
      if (n === 1) return this.choice !== 'try' || !!this.design;
      if (n === 2) return this.qty.some(function (r) { return r.checked; });
      return true;
    }

    stepValid(n) {
      if (this.stepReady(n)) return true;
      if (n === 1) {
        this.fileInputs[0].focus();
        return false;
      }
      this.qtyError.textContent = this.text.vQuantity;
      this.qty[0].focus({ preventScroll: true });
      this.qtyError.closest('fieldset').scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
      return false;
    }

    /* Ilk adimda tasarim secilene kadar tek ana islem "Tasarim sec"tir. */
    paintBar() {
      if (!this.bar) return;
      var n = this.step;
      this.backBtn.hidden = n === 1;
      this.nextBtn.hidden = n === 3;
      this.submit.hidden = n !== 3;
      this.bar.hidden = n === 1 && !this.stepReady(1);
    }

    paintMini() {
      this.mini.hidden = this.step === 1 || this.wide.matches;
    }

    picked(name) {
      var el = this.q('input[name="' + name + '"]:checked');
      return el ? el.value : '';
    }

    codes() {
      return {
        baski: PRINT_CODES[this.choice],
        adet: slug(this.picked(NAME_QTY)),
        olcu: slug(this.picked(NAME_SIZE))
      };
    }

    viewStep(n) {
      if (this.seenSteps[n]) return;
      this.seenSteps[n] = true;
      var c = this.codes();
      this.track('quote_step_view', { adim: n, baski_tercihi: c.baski, adet_araligi: c.adet, olcu_tercihi: c.olcu });
    }

    /* ---------- buyutulmus gorunum ----------
       Ayni canli sahne dialoga tasinir; kopya cizilmez, surukleme de calisir. */
    setupZoom() {
      var self = this;
      var open = this.q('[data-expand]');
      this.zoomview = this.q('[data-zoomview]');
      this.zoomBody = this.q('[data-zoom-body]');
      this.stageSlot = this.q('[data-stage-slot]');
      if (typeof this.zoomview.showModal !== 'function') { open.hidden = true; return; }
      this.on(open, 'click', function () { self.openZoom(); });
      this.on(this.stageSlot, 'click', function () { if (self.isMini()) self.openZoom(); });
      this.on(this.q('[data-zoom-close]'), 'click', function () { self.zoomview.close(); });
      this.on(this.zoomview, 'click', function (e) { if (e.target === self.zoomview) self.zoomview.close(); });
      this.on(this.zoomview, 'close', function () {
        self.stageSlot.appendChild(self.stage);
        self.fitCanvas();
      });
    }

    isMini() { return this.step > 1 && !this.wide.matches && !this.zoomview.open; }

    openZoom() {
      if (this.zoomview.open) return;
      this.zoomBody.appendChild(this.stage);
      this.zoomview.showModal();
      this.fitCanvas();
      this.touched('buyutme');
    }

    /* Ekran klavyesi acikken alt alan yapismaz. Sticky yerini akista korudugu
       icin sayfa ziplamaz, dugme de alanlarin ustune binmez. */
    setupKeyboard() {
      var self = this;
      var coarse = window.matchMedia('(pointer: coarse)');
      function typing() {
        var el = document.activeElement;
        if (!coarse.matches || !self.form.contains(el)) return false;
        return el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && !/^(radio|checkbox|range|file)$/.test(el.type));
      }
      function update() { self.classList.toggle('is-typing', typing()); }
      this.on(this.form, 'focusin', update);
      this.on(this.form, 'focusout', function () { requestAnimationFrame(update); });
    }

    /* ---------- alanlar ---------- */
    setupFields() {
      var self = this;
      this.qty = this.all('[data-qty]');
      this.qtyError = this.q('[data-qty-error]');
      this.sizeRadios = this.all('[data-size]');
      this.sizeHint = this.q('[data-size-hint]');
      this.note = this.q('[data-note]');
      this.emailBox = this.q('[data-email-box]');
      this.emailInput = this.q('[data-field="email"]');
      this.recap = this.q('[data-recap]');
      this.recapText = this.q('[data-recap-text]');
      this.required = this.all('[data-field="name"], [data-field="phone"], [data-field="email"], [data-field="consent"]');

      this.qty.forEach(function (r) {
        self.on(r, 'change', function () { self.qtyError.textContent = ''; self.paintBar(); });
      });
      this.sizeRadios.forEach(function (r) {
        self.on(r, 'change', function () { self.paintSizeHint(); });
      });
      this.on(this.form, 'input', function () { self.markStart(); });
      this.on(this.form, 'change', function () { self.markStart(); });

      this.required.forEach(function (el) {
        self.on(el, 'input', function () {
          if (el.getAttribute('aria-invalid') === 'true') self.fieldError(el, self.fieldProblem(el));
        });
        self.on(el, 'blur', function () {
          if (el.value.trim() && el.type !== 'checkbox') self.fieldError(el, self.fieldProblem(el));
        });
      });
    }

    paintSizeHint() {
      this.sizeHint.hidden = !this.q('[data-size="custom"]:checked');
    }

    recapLine() {
      var t = this.text;
      var qty = this.picked(NAME_QTY);
      var size = this.picked(NAME_SIZE);
      var parts = [{ try: t.recapTry, later: t.recapLater, none: t.recapNone }[this.choice]];
      if (this.pickedModel) parts.unshift(this.pickedModel);
      if (qty) parts.push(/\d/.test(qty) ? qty + ' ' + t.recapUnit : t.recapUnit + ': ' + qty.toLocaleLowerCase('tr-TR'));
      if (size) parts.push(size);
      return parts.join(', ');
    }

    paintRecap() {
      if (!this.recap) return;
      this.recapText.textContent = this.recapLine();
      this.recap.hidden = false;
    }

    /* Modeller bolumunde veya urun sayfasinda secilen model talebe tasinir.
       Saklama anahtari eski teklif alaniyla ortaktir; secim sayfalar arasinda kalir. */
    setupModel() {
      var self = this;
      this.pickRow = this.q('[data-picked]');
      this.pickName = this.q('[data-picked-name]');
      this.modelInput = this.form.querySelector('input[name="contact[Model]"]');
      this.modelDefault = this.modelInput.value;
      var kept = readJson(session, KEY_PICK);
      if (kept && kept.model) this.setModel(kept.model, kept.url);
      this.on(document, 'gb2:model', function (e) {
        if (e.detail && e.detail.model) self.setModel(e.detail.model, e.detail.url || '');
      });
      /* Secim uc yerde tutulur; kaldirilan model talebe ve olcume tasinmasin. */
      this.on(this.q('[data-picked-clear]'), 'click', function () {
        self.setModel('', '');
        dropSession(KEY_PICK);
        dropSession('gb2_secili_model');
        dropSession('gb2_secili_url');
        self.fileInputs[0].focus({ preventScroll: true });
      });
    }

    setModel(model, url) {
      this.pickedModel = model;
      this.pickedUrl = url;
      this.modelInput.value = model || this.modelDefault;
      this.pickName.textContent = model;
      this.pickRow.hidden = !model;
      if (model) writeSession(KEY_PICK, JSON.stringify({ model: model, url: url }));
      this.paintRecap();
    }

    markStart() {
      if (this.started) return;
      this.started = true;
      try {
        if (session().getItem(KEY_STARTED)) return;
        session().setItem(KEY_STARTED, '1');
      } catch (e) { /* depolama kapali: yine de bir kez gonderilir */ }
      this.track('quote_form_start', { adim: this.step });
    }

    fieldProblem(el) {
      var t = this.text;
      var kind = el.getAttribute('data-field');
      var v = (el.value || '').trim();
      if (kind === 'name') return v.length >= 2 ? '' : t.vName;
      if (kind === 'phone') {
        if (!v) return t.vPhone;
        return v.replace(/\D/g, '').length >= 10 ? '' : t.vPhoneBad;
      }
      if (kind === 'email') return !v || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) ? '' : t.vEmail;
      if (kind === 'consent') return el.checked ? '' : t.vConsent;
      return '';
    }

    fieldError(el, message) {
      var box = this.q('#' + el.getAttribute('aria-describedby'));
      if (message) el.setAttribute('aria-invalid', 'true');
      else el.removeAttribute('aria-invalid');
      box.textContent = message;
    }

    /* ---------- gonderim ---------- */
    setupSubmit() {
      var self = this;
      this.submit = this.q('[data-submit]');
      this.submitText = this.q('[data-submit-text]');
      this.fail = this.q('[data-fail]');
      this.uploadFail = this.q('[data-upload-fail]');
      /* Yakalama asamasi: gb2-olcum'un submit dinleyicisi formun kendisinde ve
         defaultPrevented'a bakiyor. Dogrulama ondan ONCE calismali. */
      this.on(this, 'submit', function (e) { self.onSubmit(e); }, { capture: true });
      this.on(this.q('[data-retry]'), 'click', function () { self.sendForm(); });
      this.on(this.q('[data-upload-retry]'), 'click', function () { self.sendForm(); });
      this.on(this.q('[data-upload-skip]'), 'click', function () {
        self.uploadSkipped = true;
        self.sendForm();
      });
      this.on(window, 'pageshow', function (e) {
        if (!e.persisted) return;
        var kept = readJson(session, KEY_DONE);
        var id = self.form.querySelector('input[name="' + NAME_ID + '"]');
        if (kept && id && kept.id === id.value) {
          self.setSending(false);
          self.showDone(kept);
        } else if (self.sending) {
          self.setSending(false);
          self.showFail('baglanti');
        }
      });
    }

    sendForm() {
      if (this.form.requestSubmit) this.form.requestSubmit(this.submit);
      else this.submit.click();
    }

    onSubmit(e) {
      /* hCaptcha'nin submit dinleyicisi defaultPrevented'a bakmaz; yalniz engellemek
         yetmez, gecersiz gonderim yine dogrulamaya gidip POST edilir. Olay forma
         hic ulasmamali. */
      function halt() {
        e.preventDefault();
        e.stopPropagation();
      }
      if (this.sending) { halt(); return; }
      if (this.step < 3) { halt(); this.next(); return; }
      var self = this;
      var first = null;
      this.required.forEach(function (el) {
        var problem = self.fieldProblem(el);
        self.fieldError(el, problem);
        if (problem && !first) first = el;
      });
      if (first) {
        halt();
        if (first === this.emailInput) this.emailBox.open = true;
        first.focus({ preventScroll: true });
        first.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        this.track('quote_form_submit_error', { hata_turu: 'dogrulama' });
        return;
      }
      this.fail.hidden = true;
      this.uploadFail.hidden = true;
      this.fillHidden();
      this.saveDraft();
      /* Dosya once yuklenir. Bu olay forma ulasmaz; gb2-olcum ve hCaptcha ancak
         yukleme bitip form yeniden gonderilince devreye girer. */
      if (this.needsUpload()) {
        halt();
        this.uploadThenSend();
        return;
      }
      this.setSending(true);
      this.watchSend();
    }

    /* ---------- dosya teslimi ----------
       Yalnizca dosya servisi adresi ayarliysa calisir. Orijinal dosya ve son
       mockup ayni Talep Kimligi ile yuklenir, sonra form gider. Servis, Shopify
       bildirimini gorunce dosyalari e-postayla iletir. Basarisiz yuklemede form
       bilgileri durur; ayni kimlikle yeniden deneme yeni kayit acmaz. */
    fileStamp() {
      var f = this.activeFile().file;
      return [f.name, f.size, f.lastModified].join('|');
    }

    placeStamp() {
      return [this.fileStamp(), this.x, this.y, this.size, this.mode, this.activeFile().useKey].join('|');
    }

    delivered() {
      var s = this.sent;
      if (!s || !this.uploadUrl || !this.activeFile()) return false;
      return s.original === this.fileStamp() && s.mockup === this.placeStamp();
    }

    needsUpload() {
      return !!this.uploadUrl && !!this.activeFile() && !this.uploadSkipped && !this.delivered();
    }

    /* gb2-olcum ayni alani okur; kimlik burada uretildiyse yenisini uretmez. */
    requestId() {
      var el = this.form.querySelector('input[name="' + NAME_ID + '"]');
      if (el && el.value) return el.value;
      var id = 'g' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      this.hidden(NAME_ID, id);
      return id;
    }

    uploadThenSend() {
      var self = this;
      this.setSending(true, this.text.uploading);
      this.announce(this.text.uploading);
      this.deliver().then(function () {
        self.track('quote_file_upload', { durum: 'tamam' });
        self.setSending(false);
        self.sendForm();
      }).catch(function (err) {
        self.setSending(false);
        self.showUploadFail(err);
      });
    }

    deliver() {
      var self = this;
      var d = this.activeFile();
      var id = this.requestId();
      var sent = this.sent = this.sent || {};
      var fileStamp = this.fileStamp();
      var placeStamp = this.placeStamp();
      var chain = Promise.resolve();
      if (sent.mockup !== placeStamp) {
        chain = chain.then(function () { return self.exportForUpload(); }).then(function (url) {
          if (!url) throw new Error('mockup');
          return self.postFile({ talep: id, tur: 'mockup', ad: 'mockup.jpg', veri: url.split(',')[1] });
        }).then(function () { sent.mockup = placeStamp; });
      }
      if (sent.original !== fileStamp) {
        chain = chain.then(function () { return toBase64(d.file); }).then(function (data) {
          return self.postFile({ talep: id, tur: 'orijinal', ad: d.file.name, veri: data });
        }).then(function () { sent.original = fileStamp; });
      }
      return chain;
    }

    /* text/plain: servis CORS on istegine yanit veremez. Tanimlayici gonderilmez. */
    postFile(payload) {
      var watch = new AbortController();
      var timer = setTimeout(function () { watch.abort(); }, UPLOAD_TIMEOUT);
      return fetch(this.uploadUrl, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        redirect: 'follow',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        signal: watch.signal
      }).then(function (r) { return r.json(); }).then(function (res) {
        clearTimeout(timer);
        if (!res || res.ok !== true) throw new Error((res && res.hata) || 'sunucu');
      }, function (err) {
        clearTimeout(timer);
        throw err;
      });
    }

    /* Yukleme icin fotografin en buyuk surumu kullanilir; yerlesim ayni motorla
       cizildigi icin sonuc ziyaretcinin son gordugu mockup'tir. */
    exportForUpload() {
      var self = this;
      return new Promise(function (resolve) {
        var full = new Image();
        full.crossOrigin = 'anonymous';
        full.onload = function () {
          resolve(self.exportMockup(Math.min(full.naturalWidth, UPLOAD_WIDTH), UPLOAD_QUALITY, full));
        };
        full.onerror = function () { resolve(self.exportMockup(MOCKUP_WIDTH, UPLOAD_QUALITY)); };
        full.src = self.q('[data-base]').getAttribute('data-full');
      });
    }

    showUploadFail(err) {
      var code = err && UPLOAD_ERRORS.indexOf(err.message) > -1 ? err.message : 'baglanti';
      this.uploadFail.hidden = false;
      this.goTo(3);
      this.uploadFail.focus({ preventScroll: true });
      this.uploadFail.scrollIntoView({ block: 'center' });
      this.track('quote_file_upload', { durum: 'hata', hata_turu: code });
    }

    /* Sayfa degismediyse gonderim sonuclanmamistir. hCaptcha gorsel dogrulama
       acarsa ziyaretci cozene kadar beklenir; pencere kapanip form gitmediyse
       dogrulama iptal edilmistir, dugme takili kalmaz. */
    watchSend() {
      var self = this;
      var started = Date.now();
      var seen = false;
      var closedAt = 0;
      this.sendTimer = setInterval(function () {
        if (challengeOpen()) {
          seen = true;
          closedAt = 0;
          return;
        }
        if (seen && !closedAt) closedAt = Date.now();
        var late = closedAt ? Date.now() - closedAt > CHALLENGE_GRACE : Date.now() - started > SEND_TIMEOUT;
        if (!late) return;
        self.setSending(false);
        self.showFail('zaman_asimi');
      }, 1000);
    }

    setSending(on, label) {
      this.sending = on;
      clearInterval(this.sendTimer);
      this.form.setAttribute('aria-busy', String(on));
      this.submit.classList.toggle('is-busy', on);
      this.backBtn.disabled = on;
      this.submitText.textContent = on ? (label || this.text.sending) : this.text.submit;
    }

    showFail(kind) {
      /* Tema gonderim baslarken tam ekran beyaz katman acar, sayfa degismezse
         kapatmaz; yeniden deneme alani onun altinda kalmasin. */
      var veil = document.querySelector('.m-page-transition');
      if (veil) veil.classList.remove('fade-in');
      this.fail.hidden = false;
      this.goTo(3);
      this.fail.focus({ preventScroll: true });
      this.fail.scrollIntoView({ block: 'center' });
      this.track('quote_form_submit_error', { hata_turu: kind });
    }

    hidden(name, value) {
      var el = this.form.querySelector('input[type="hidden"][name="' + name + '"]');
      if (!value) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        this.form.appendChild(el);
      }
      el.value = String(value).slice(0, 400);
    }

    /* Kaynak bilgisi gb2-olcum'un kendi deposundan OKUNUR; bu dosya yazmaz.
       Oturum kaynagi once gelir, yoksa ilk gelis kullanilir. */
    fillHidden() {
      var self = this;
      var d = this.activeFile();
      var t = this.text;

      var status = { try: t.statusTry, later: t.statusLater, none: t.statusNone }[this.choice];
      if (d && this.uploadUrl) status = this.delivered() ? t.statusSent : t.statusFailed;
      this.hidden('contact[Tasarim durumu]', status);
      this.hidden('contact[Tasarim dosyasi]', d ? d.file.name.slice(0, 150) + ' (' + formatSize(d.file.size) + ', ' + d.width + ' × ' + d.height + ' px)' : '');
      this.hidden('contact[Tasarim yerlesimi]', d ? 'Yatay %' + Math.round(this.x * 100) + ', dikey %' + Math.round(this.y * 100) + ', boyut %' + Math.round(this.size) : '');

      var visit = readJson(session, 'gb2-oturum-kaynak') || {};
      var first = readJson(local, 'gb2-ilk-gelis') || {};
      SOURCE_FIELDS.forEach(function (f) {
        self.hidden('contact[' + f[1] + ']', visit[f[0]] || first[f[0]]);
      });
      this.hidden('contact[Ilk giris sayfasi]', first.ilk_sayfa || visit.ilk_sayfa);
      this.hidden('contact[Form sayfasi]', window.location.pathname);

      /* Katalogda secilen model ve urun sayfasi talebe tasinir; ziyaretci bu
         sayfaya dogrudan geldiyse secili_model bez canta olarak yazilir. */
      var label = this.config.models[this.model].label;
      try {
        var stored = session().getItem('gb2_secili_model');
        this.hidden('contact[Urun sayfasi]', this.pickedUrl || session().getItem('gb2_secili_url'));
        if (!stored) session().setItem('gb2_secili_model', label);
      } catch (e) { /* depolama kapali */ }
    }

    /* Mobilde sahne kuculur; mockup sabit genislikte cizilir. Motor cozunurlukten
       bagimsiz oldugu icin sonuc ayni, yalnizca daha net. */
    exportMockup(width, quality, base) {
      var c = this.canvas;
      var w = c.width;
      var h = c.height;
      var kept = this.bases[this.model];
      var url = '';
      try {
        if (base) this.bases[this.model] = base;
        c.width = width;
        c.height = Math.round(width / this.ratio);
        this.fabric = null;
        this.render();
        url = c.toDataURL('image/jpeg', quality);
      } catch (e) { /* onizleme gorseli olmadan da taslak korunur */ }
      this.bases[this.model] = kept;
      c.width = w;
      c.height = h;
      this.fabric = null;
      this.render();
      return url;
    }

    saveDraft() {
      var values = {};
      this.form.querySelectorAll('input[name^="contact["], textarea').forEach(function (el) {
        if (el.type === 'hidden') return;
        if (el.type === 'radio') { if (el.checked) values[el.name] = el.value; return; }
        values[el.name] = el.type === 'checkbox' ? el.checked : el.value;
      });
      var d = this.activeFile();
      writeSession(KEY_DRAFT, JSON.stringify({
        path: window.location.pathname,
        at: Date.now(),
        id: this.requestId(),
        values: values,
        hasFile: !!d,
        delivered: this.delivered(),
        recap: this.recapLine(),
        codes: this.codes(),
        mockup: d ? this.exportMockup(MOCKUP_WIDTH, 0.82) : '',
        place: d ? { x: this.x, y: this.y, size: this.size, mode: this.mode, useKey: d.useKey } : null
      }));
    }

    /* Bir onceki gonderim sonuclanmadiysa bilgiler geri gelir ve hata gorunur.
       Taslak yalnizca gonderildigi sayfada ve kisa sure gecerlidir: ana sayfada
       bosuna hata gosterip ziyaretciyi forma kaydirmaz. */
    restore() {
      var self = this;
      var draft = readJson(session, KEY_DRAFT);
      var serverError = !this.fail.hidden;
      if (draft && (draft.path !== window.location.pathname || !(Date.now() - draft.at < DRAFT_AGE))) {
        dropSession(KEY_DRAFT);
        draft = null;
      }
      if (!draft) {
        clearFile();
        if (serverError) { this.goTo(3); this.revealFail(); this.track('quote_form_submit_error', { hata_turu: 'sunucu' }); }
        return;
      }
      if (draft.id) this.hidden(NAME_ID, draft.id);
      this.form.querySelectorAll('input[name^="contact["], textarea').forEach(function (el) {
        if (el.type === 'hidden' || !(el.name in draft.values)) return;
        if (el.type === 'radio') el.checked = el.value === draft.values[el.name];
        else if (el.type === 'checkbox') el.checked = draft.values[el.name];
        else el.value = draft.values[el.name];
      });
      var choice = this.choices.filter(function (r) { return r.checked; })[0];
      this.setChoice(choice ? choice.getAttribute('data-choice') : 'try');
      this.paintSizeHint();
      this.note.open = !!this.q('textarea[name="contact[body]"]').value.trim();
      this.emailBox.open = !!this.emailInput.value.trim();
      if (draft.hasFile) {
        readFile().then(function (file) {
          if (!file) return;
          return self.readDesign(file).then(function () {
            var p = draft.place;
            self.x = p.x;
            self.y = p.y;
            self.size = p.size;
            self.setMode(p.mode);
            self.design.useKey = p.useKey;
            self.paintFileRow();
            self.render();
          });
        }).catch(function () { /* dosya okunamadiysa form bilgileri yine korunur */ });
      }
      this.fail.hidden = false;
      this.goTo(3);
      this.revealFail();
      this.track('quote_form_submit_error', { hata_turu: serverError ? 'sunucu' : 'baglanti' });
    }

    /* Geri gelince tarayici eski kaydirma konumunu yuklemeden sonra uygular;
       hata paneli o yuzden yukleme bittikten sonra da ekrana getirilir. */
    revealFail() {
      var fail = this.fail;
      function show() {
        fail.focus({ preventScroll: true });
        fail.scrollIntoView({ block: 'center' });
      }
      show();
      if (document.readyState === 'complete') return;
      this.on(window, 'load', function () { setTimeout(show, 0); }, { once: true });
    }

    /* ---------- basari ----------
       Adres tek basina basari sayilmaz. Karari gb2-olcum verir; generate_lead'i de
       yalnizca o gonderir. Kabul edilen talep oturumda saklanir: sayfa yenilenir
       veya geri gelinirse ayni ekran acilir, yeni olay uretilmez.
       quote_form_submit_success kabule baglidir ve Ads donusumu degildir. */
    acceptance() {
      var fresh = window.gb2TeklifKabul;
      var kept = readJson(session, KEY_DONE);
      if (!fresh) {
        return kept && (this.q('[data-ok]') || navigationKind() === 'back_forward') ? kept : null;
      }
      var draft = readJson(session, KEY_DRAFT) || {};
      var c = draft.codes || {};
      kept = {
        id: fresh.talep_kimligi,
        recap: draft.recap || '',
        hasFile: !!draft.hasFile,
        delivered: !!draft.delivered,
        mockup: draft.mockup || ''
      };
      writeSession(KEY_DONE, JSON.stringify(kept));
      dropSession(KEY_DRAFT);
      clearFile();
      if (fresh.yeni) this.track('quote_form_submit_success', { baski_tercihi: c.baski, adet_araligi: c.adet, olcu_tercihi: c.olcu });
      return kept;
    }

    showDone(record) {
      var veil = document.querySelector('.m-page-transition');
      if (veil) veil.classList.remove('fade-in');
      this.classList.add('is-done');
      this.classList.remove('has-file');
      this.setAttribute('data-at', '1');
      this.all('.gb-quote-intro, [data-steps], [data-panel], [data-action-bar], [data-mini]').forEach(function (el) {
        el.hidden = true;
      });
      this.q('[data-done]').hidden = false;

      if (record.id) {
        this.q('[data-done-id-value]').textContent = record.id;
        this.q('[data-done-id]').hidden = false;
      }
      if (record.recap) {
        this.q('[data-done-recap]').textContent = record.recap;
        this.q('[data-done-recap]').hidden = false;
      }
      this.q('[data-done-file]').hidden = !(record.hasFile && record.delivered);
      if (record.hasFile && !record.delivered) {
        var wa = this.q('[data-done-wa]');
        wa.setAttribute('data-gb2-wa', '1');
        wa.setAttribute('data-gb2-wa-text', encodeURIComponent(this.text.waText + (record.id ? ' Talep kimliği: ' + record.id : '')));
        this.q('[data-done-design]').hidden = false;
      }
      if (record.mockup && !this.q('.gb-quote-stage-mockup')) {
        var mockup = new Image();
        mockup.className = 'gb-quote-stage-mockup';
        mockup.alt = this.q('[data-base]').alt;
        mockup.src = record.mockup;
        this.q('[data-stage]').appendChild(mockup);
      }

      /* Tema yuklenirken odagi birakiyor: sayfa yuklenince odak yeniden verilir. */
      var title = this.q('[data-done-title]');
      function focusTitle() {
        requestAnimationFrame(function () { title.focus({ preventScroll: true }); });
      }
      this.land(this.form);
      focusTitle();
      if (document.readyState !== 'complete') this.on(window, 'load', focusTitle, { once: true });
    }

    /* Hedefe kesin inis. Temanin yumusak kaydirmasi WebKit'te yarida kesilebiliyor,
       bu yuzden anlik yapilir; sayfa yuklenince ziyaretci dokunmadiysa bir kez daha. */
    land(target) {
      var moved = false;
      function go() {
        if (!moved) target.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
      go();
      if (document.readyState === 'complete') return;
      this.on(window, 'wheel', function () { moved = true; }, { once: true, passive: true });
      this.on(window, 'touchmove', function () { moved = true; }, { once: true, passive: true });
      this.on(window, 'load', go, { once: true });
    }
  }

  window.customElements.define('gb-quote-studio', GbQuoteStudio);
})();
